import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const PageBodyStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 3rem;
  overflow: auto;
  ${css.compactMedia} {
    padding: 0 1.5rem;
  }
  ${css.mobileMedia} {
    padding: 0 1rem;
  }
  @media only screen and (max-height: 1000px) {
    overflow: visible;
  }
`;

interface PageBodyProps {
  className?: string,
  children: React.ReactNode,
}

/** Scrollable page body container. */
export const PageBody = (props: PageBodyProps) => {
  return (
    <PageBodyStyled className={`page-body${props.className ? ` ${props.className}` : ''}`}>
      {props.children}
    </PageBodyStyled>
  );
};